import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeAnalyticsData } from '@atlassian/mpac-analytics';
import { foldAuthType } from '@atlassian/mpac-types';
import { FINISH_REVOKE_USER_GRANT_GLOBALLY, FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT, FINISH_UNINSTALL_APP_FROM_SITE, REVOKE_USER_GRANT_GLOBALLY_ERROR, UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR, UNINSTALL_APP_FROM_SITE_ERROR } from '../../../actions/InstalledApps';
import { resolveFieldWithFallback } from '../../../utils/common-utils';
import { ANALYTICS_CATEGORY_NAVIGATION, ANALYTICS_CATEGORY_UNINSTALL, AppRemovedEvent, AppRemoveFailedEvent, TokenRemovedEvent, TokenRemoveFailedEvent, UserGrantRemovedEvent, UserGrantRemoveFailedEvent } from '../../Events';
const createUninstallEvent = (appEventType, tokenEventType, installedApp, context, removedFrom, extraAttributes) => foldAuthType(installedApp.authType)(_ => makeAnalyticsData({
  eventType: tokenEventType,
  actionSubjectId: 'token',
  attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
    authType: 'token',
    removedFrom
  }),
  category: ANALYTICS_CATEGORY_UNINSTALL
}), _ => makeAnalyticsData({
  eventType: appEventType,
  actionSubjectId: installedApp.details.key,
  attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
    name: installedApp.details.name,
    authType: '2LO',
    removedFrom,
    oauthClientId: installedApp.details.metadata.oauthClientId
  }),
  category: ANALYTICS_CATEGORY_UNINSTALL
}), _ => makeAnalyticsData({
  eventType: appEventType,
  actionSubjectId: installedApp.details.key,
  attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
    name: installedApp.details.name,
    authType: '3LO',
    removedFrom,
    oauthClientId: installedApp.details.metadata.oauthClientId
  }),
  category: ANALYTICS_CATEGORY_UNINSTALL
})).set('containerType', 'context').set('containerId', context.id);
export default function UninstallAppMapper(action) {
  switch (action.type) {
    case FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT:
      return createUninstallEvent(AppRemovedEvent, TokenRemovedEvent, action.installedApp, action.context, 'context');
    case UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR:
      return createUninstallEvent(AppRemoveFailedEvent, TokenRemoveFailedEvent, action.installedApp, action.context, 'context', {
        error: action.message
      });
    case FINISH_UNINSTALL_APP_FROM_SITE:
      return createUninstallEvent(AppRemovedEvent, TokenRemovedEvent, action.installedApp, action.context, 'site');
    case UNINSTALL_APP_FROM_SITE_ERROR:
      return createUninstallEvent(AppRemoveFailedEvent, TokenRemoveFailedEvent, action.installedApp, action.context, 'site', {
        error: action.message
      });
    case FINISH_REVOKE_USER_GRANT_GLOBALLY:
      return makeAnalyticsData({
        eventType: UserGrantRemovedEvent,
        objectType: 'app',
        objectId: action.installedApp.details.key,
        actionSubjectId: action.userGrant.user.atlassianAccountId,
        attributes: {
          name: resolveFieldWithFallback(add => add.name, action.installedApp.marketplaceAppDetails, action.installedApp.details)
        },
        category: ANALYTICS_CATEGORY_NAVIGATION
      });
    case REVOKE_USER_GRANT_GLOBALLY_ERROR:
      return makeAnalyticsData({
        eventType: UserGrantRemoveFailedEvent,
        objectType: 'app',
        objectId: action.installedApp.details.key,
        actionSubjectId: action.userGrant.user.atlassianAccountId,
        attributes: {
          name: resolveFieldWithFallback(add => add.name, action.installedApp.marketplaceAppDetails, action.installedApp.details),
          error: action.message
        },
        category: ANALYTICS_CATEGORY_NAVIGATION
      });
  }
}